const en = {
    common: {
        yes: "Yes",
        no: "No",
        skip: "Skip this question",
        optional: "Optional",
        remove: "Remove",
        update: "Update",
        "New York": 'New York',
        Vermont: 'Vermont',
        month: 'month',
        errors: {
            invalidDate: 'Please enter a valid date.',
            invalidEmail: 'Please enter a valid email.',
            invalidPhone: 'Please enter a valid phone number.',
            invalidZip: 'Please provide a valid 5-digit zip code.',
            futureBirthday: 'Birthday cannot be a future date.'
        },
        fields: {
            firstName: "First Name",
            middleInitial: "Middle Initial (Optional)",
            lastName: "Last Name",
            suffix: "Suffix (Optional)",
            gender: "Gender",
            birthday: "Birthday",
            ssn: "SSN",
            donateLifeOptIn: "Donate Life Registry",
            socialsecno: "Social Security Number",
            address: "Address",
            primaryAddress: "Primary Address",
            primaryPhone: "Primary Phone",
            mailingAddress: "Mailing Address",
            mailingPhone: "Mailing Phone",
            city: "City",
            state: "State",
            county: "County",
            zip: "ZIP Code",
            email: "Email",
            name: "Name",
            relation: "Relation"
        }
    },
    header: {
        speakWith: 'Speak with an MVP agent:',
        title: 'Enroll Now'
    },
    sidebar: {
        step1: "Eligibility",
        step2: "Subscriber Information",
        step3: "Dependent Information",
        step4: "Review Selections",
        progress: "Your Progress",
        complete: "Enrollment Complete!",
    },
    planDetails: {
        title1: 'Additional Plan Info',
        title2: 'Plan Benefits & Limits',
        effectiveDate: 'Effective Date',
        monthlyPremium: 'Monthly Premium',
        state: 'State',
        planName: 'Plan Name',
        planType: 'Plan Type',
        singlePlan: 'Single Plan',
        familyPlan: 'Family Plan',
        exchange: 'Exchange',
        metalLevel: 'Metal Level',
        innDeductible: "Annual INN Deductible",
        oonDeductible: "Annual OON Deductible",
        innOopLimit: "Annual INN OOP LIMIT",
        oonOopLimit: "Annual OON OOP LIMIT",
        primaryCare: "Primary Care Visit",
        specialist: "Specialist",
        planYear: "Plan Year",
        rxCoverage: "Rx Coverage",
        rxType: "Generic / Preferred / Non-Preferred",
        abbreviated: {
            innDeductible: "Ann INN Deductible",
            oonDeductible: "Ann OON Deductible",
            innOopLimit: "Ann INN OOP LIMIT",
            oonOopLimit: "Ann OON OOP LIMIT",
            rxType: "Generic / Pref / Non-Pref",
        }
    },
    eligibility: {
        title: "Step 1 - Eligibility",
        coverage: {
            text: "Who will the plan cover?",
            subtext: "Select all that apply. If you do not select any you will be enrolling for just yourself.",
            self: "Myself",
            spouse: "My spouse",
            dependents: "My dependent(s)"
        },
        subscriberInfo: {
            title: "Tell us more about you."
        },
        dependentInfo: {
            title: "Who else will your plan cover?",
            spouse: "Spouse Details",
            dependent: "Dependent {{count}} details",
            additional: "Add an additional dependent",
            addButton: "Add Dependent",
            removeButton: "Remove Dependent"
        },
        contactInfo: {
            title: "Your Contact Information",
            emailAndPhone: "Contact Email and Phone",
            homeAddress: "Home Address",
            isMailingHome: "Mailing Address is the same as Home Address",
            mailingInfo: "Mailing Contact Information",
            mailingPhone: "Mailing Phone",
            mailingAddress: "Mailing Address",
        },
        moreQuestions: {
            title: "There are a few more questions before we get started.",
            q1: "Do you have any dependents between 26-29 years old?",
            q2: {
                text: "Do you have pediatric dental coverage already for your dependents under 19?",
                info: "Pediatric dental coverage is required by the Affordable Care Act (ACA), and is included as part of this quote and enrollment process. If you certify that you already have pediatric dental coverage, then this coverage can be removed from your quote: Pediatric Dental: Family Plan $30.46/month."
            },
            q3: {
                title: "Pediatric Dental Details",
                inputPlaceHolder1: "Company Providing Pediatric Dental Policy",
                inputPlaceHolder2: "Policy Number",
                termsCondition: "I hereby certify that I already have pediatric dental coverage under a separate policy.",
            },
            q4: "Are you enrolling on behalf of someone else?",
            q5: {
                question: "What is your relation to the subscriber?",
                dropdownPlaceholder: {
                    text: "Relation to Subscriber",
                    Broker: "I am a Broker",
                    CaregiverGuardian: "Enrolling on behalf of Subscriber"
                }
            },
            q6: {
                question: "Additional Broker Information",
                info1: "Your Contact Information",
                placeholder1: "Broker First Name",
                placeholder2: "Broker Last Name",
                placeholder3: "Broker Email",
                info2: "Agency Details",
                placeholder4: "Agency Name",
                placeholder5: "MVP Agency Number"
            }
        },
        qualifyingEvents: {
            lifeEvent: {
                title: "What is your qualifying life event?",
                subtitle: "Select which, if any, of the following have occurred in the last 60 days.",
                body: "If more than one of these events occurred, select the one that happened most recently.",
            },
            tooltips: {
                Other: {
                    "New York": `If you're already enrolled in a Marketplace plan, having a change in income or household 
                        status that affects eligibility for premium tax credits or cost-sharing reductions may allow you to 
                        make changes under special enrollment. If your coverage ends due to COBRA expiration, loss of eligibility 
                        for Medicaid or Child Health Plus, or you experience other more complex circumstances, you may be eligible 
                        for a new plan. Call 1-800-TALK-MVP to discuss your eligibility for special enrollment.`,
                    Vermont: `If you're already enrolled in a Marketplace plan, having a change in income or household 
                        status that affects eligibility for premium tax credits or cost-sharing reductions may allow you to 
                        make changes under special enrollment. If your coverage ends due to COBRA expiration, loss of eligibility 
                        for Medicaid or Dr. Dynasaur, or you experience other more complex circumstances, you may be eligible 
                        for a new plan. Call 1-800-TALK-MVP to discuss your eligibility for special enrollment.`
                }
            },
            eventDate: {
                title: "When did your qualifying event occur?",
                subtitle: "Select the date that the qualifying event chosen above occurred.",
                calendarLabel: "Event Date"
            },
            labels: {
                "New York": {
                    EmployerLoss: 'I lost my employer health plan',
                    MaritalStatusChange: 'My marital status changed (married or divorced)',
                    OutOfStateMove: 'I moved to New York from another state',
                    NewChild: 'I welcomed a new child into my family',
                    Pregnancy: 'Pregnancy',
                    Other: 'Other',
                    None: 'None of these apply'
                },
                Vermont: {
                    EmployerLoss: 'Loss of affordable minimum essential coverage or government-sponsored coverage',
                    MaritalStatusChange: 'Change in marital status',
                    OutOfStateMove: 'Move to Vermont, change in citizenship/immigration status',
                    NewChild: 'Gain a dependent through marriage, birth or adoption',
                    Pregnancy: 'Pregnancy',
                    IncomeChange: 'Change in income',
                    Other: 'Other',
                    None: 'None of these apply'
                },
            },
            errors: {
                futureDate: "Qualifying event dates cannot be future dates.",
                recentDate: "Qualifying event dates must have occurred within the past 60 days."
            },
        }
    },
    reviewSelection: {
        legalAgreements: {
            title: 'Legal Agreements',
            readAndUnderstand: "I have read and understand the above.",
            attestation: {
                title: 'Benefits Summary Attestation',
                sbc: 'Summary of Benefits and Coverage* (SBC)',
                option1: 'I have read the <LinkComponent /> outlining my plan coverage and benefits.',
                option2: 'Please email me a copy of my SBC document (optional)'
            },
            directPurchaseReminder: {
                title: 'Direct Purchase Reminder',
                text: `Only plans purchased through {{planState}} State of Health™ Marketplace are eligible for financial assistance from the 
                government such as Advanced Premium Tax Credits (APTC) or Cost-Sharing Reductions (CSR). I understand that I am enrolling in 
                a plan that is NOT eligible for APTC, CSR or any financial assistance from the government. I understand that the subsidy calculation 
                on this website is just an estimation and is not an official determination of eligibility and that it is my responsibility to 
                confirm my official eligibility for subsidies at the {{planStateMarketplace}} at <LinkComponent />.`,
                "New York": 'New York State of Health Marketplace',
                Vermont: 'Vermont Health Connect Marketplace'
            },
            enrollment: {
                title: 'Enrollment Agreement',
                text: `I understand that my plan effective date and successful plan enrollment will be dependent upon timely receipt of my 
                1st month’s payment along with the verification of enrollment information I have provided.`,
                antiFraud: `Anti-Fraud Declaration: I attest that I have not knowingly and with intent to defraud any insurance company or 
                person by filing an application for insurance containing any materially false or misleading information. Insurance fraud is 
                a crime and shall be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for 
                each such violation.`
            }
        }, 
        reviewSubscriber: {
            primary: {
                title: 'Primary Subscriber Information'
            },
            dependents: {
                title: 'Spouse and Dependents',
                noDependents: "No dependents have been selected for this enrollment.",
            }
        }
    },
    postEnrollment: {
      enrollmentMessage: "You’re Enrolled, {{firstName}}!",
      title: "Thanks for Choosing MVP!",
        print: "Print",
      ourWebSite: "our website",
      nextSteps: {
        title: "What’s Next?",
        text:
          "The last step before your enrollment is processed is to pay your <boldText>first month’s premium</boldText>. You’ll receive an invoice in the mail, but the easiest way to pay is on <LinkComponent/> using Express Pay. Note: It may take up to 2 business days to set up your account before online payment is available.",
      },
      hsa: {
        title: "You Qualify for a Health Savings Account!",
        body: "We want to make sure you get the most out of your high-deductible health plan (HDHP) from MVP. Open a Health Savings Account (HSA) with MVP to save on out-of-pocket medical and pharmacy costs, and <boldText>MVP will cover your monthly HSA administration fees in full<redText>¹</redText>!</boldText>",
        cta: "Learn More",
        disclaimer:
          "<boldText>1</boldText> No cost HSA available from January 1, 2026 – December 31, 2026. Restrictions may apply. An HDHP must be qualified to be eligible to pair with an HSA. To be qualified, the HDHP must meet the yearly minimum deductible and out-of-pocket maximum (OOPM) requirements. In 2026, the deductible minimum requirement is $1,700/$3,400 (individual/family) and the OOPM maximum requirement is $8,500/$17,000 (individual/family).",
      },
    },
    effectiveDates: {
        title: "Effective Start Date",
        subtitle: "Select your start date for coverage.",
        explanation: "Your effective plan start date is contingent upon our timely receipt of your 1st month's payment, also called your 'binder payment' before the period."
    },
    modal: {
        title: 'Call Us to Complete Enrollment',
        thankYou: ". Thank you.",
        over65: {
            part1: "If you are 65 or older, for information on how to enroll in Medicare through MVP, please call ",
        },
        under19: {
            part1: "If you or your spouse are under the age of 19 then your application will require manual processing.",
            part2: " For enrollment assistance please contact ",
        },
        submissionError: {
            title: 'Error: Unable to Submit',
            unableToSubmit: 'We were unable to submit your application at this time. Please try again.'
        },
        planNotFound: {
            title: 'Unable to Find Your Plan',
            descriptionBeginning: 'We are unable to pull the plan you had selected. Please return to the',
            descriptionEnding: 'page to begin your online enrollment.',
            linkText: 'Plan Shopping'
        },
        continue: {
            beginning: 'If you continue to get this message please call',
            ending: 'to finish enrolling'
        },
        between26and29: {
            part1: "Enrolling dependents between the ages of 26 and 29 will require manual processing (a plan rider will need to be purchased). For enrollment assistance please contact ",
        },
        effectiveDateError: {
            title: 'Call Us to Complete Enrollment',
            part1: 'We are unable to process your online enrollment at this time due to questions on your effective date. Please call ',
            phoneNumber: '',
            part2: ' and a representative will be happy to assist with your enrollment.',
        },
        lifeEvent: {
            text: 'You selected {{type}} as your life event and we will need a little more information to complete your application.<br/><br/> Please call <PhoneComponent>{{phoneNumber}}</PhoneComponent> to finish enrolling.',
            types: {
                Pregnancy: 'Pregnancy',
                Other: 'Other',
                None: 'None'
            }
        }
    },
    donateLife: {
        page: {
            topOverline: 'You must fill out the following section',
            title: 'Would you (applicant) like to be added to the New York State Donate Life Registry?',
            subTitle: 'Select either “Yes” or “Skip this question”',
            yesButton: 'Yes',
            skipButtonText: 'Skip this question'
        },
        footer: {
            text: 'The New York State Donate Life Registry is a database of people who have signed up to donate their organs, eyes, and/or tissues after their death. This database is kept confidential. Current registrants can access their donor profile at <LinkComponent />.'
        }
    }
}

export default en;